import axios from "axios";
import Cookies from "js-cookie";
import { BASE_URL } from "../config";

export class TokenService {
    private static token: string | null = null;
    private static refreshToken: string | null = null;

    static getAccessToken(): string {
        return TokenService.token ??
            localStorage.getItem('accessToken') ??
            Cookies.get('accessToken') ?? "";
    }

    static setAccessToken(token: string): void {
        TokenService.token = token;
    }

    static getRefreshToken(): string {
        return TokenService.refreshToken ??
            localStorage.getItem('refreshToken') ??
            Cookies.get('refreshToken') ?? "";
    }

    static setRefreshToken(token: string): void {
        TokenService.refreshToken = token;
        localStorage.setItem('refreshToken', token);
    }

    static async refreshAccessToken() {
        try {
            const res = await axios.post(
                `api/user/refresh-token`,
                {
                    refreshToken: this.getRefreshToken()
                },
                {
                    baseURL: BASE_URL,
                    headers: {
                        refreshToken: this.getRefreshToken()
                    },
                    validateStatus: (status: any) => {
                        return status >= 200
                    }
                }
            );

            if (res.status === 200) {
                this.setAccessToken(res.data.data.access_token.token);
                this.setRefreshToken(res.data.data.refreshToken.token);

                // Setting refreshToken in Cookies
                let user = JSON.parse(localStorage.getItem("user") ?? (Cookies.get("user") ?? "{}"));
                user.refreshToken = res.data.data.refreshToken;
                user.accessToken = res.data.data.access_token;
                this.setMasterState(user);
                return this.getAccessToken();
            } else {
                localStorage.removeItem("user");
                Cookies.remove('user');
                return "";
            }
        } catch (err) {
            console.log(err);
            localStorage.removeItem("user");
            Cookies.remove('user');
            return "";
        }
    }

    static setMasterState(data: any) {
        if (localStorage.getItem("user")) {
            localStorage.setItem("user", JSON.stringify(data));
        }
        else {
            Cookies.set("user", JSON.stringify(data));
        }
    }

    static clearToken(): void {
        TokenService.token = null;
        TokenService.refreshToken = null;
    }
}
